import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {hydrateKsExperimentsFromStorage} from '../../utils/monetate-ab-test-utils'

const MonetateScript = () => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {monetate} = commerceAPI
    const {config} = monetate || {}

    var monetateEnabled = false
    var monetateScriptURL = null

    try {
        const jsonConfig = JSON.parse(config)
        monetateEnabled = jsonConfig.enabled
        monetateScriptURL = jsonConfig.scriptURL
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        hydrateKsExperimentsFromStorage()
    }, [])

    useEffect(() => {
        if (monetateEnabled && monetateScriptURL) {
            //sync Monetate implementation has 2 scripts to be included
            const script1 = document.createElement('script')
            script1.type = 'text/javascript'
            script1.defer = true
            script1.textContent = 'var monetateT = new Date().getTime();'

            const script2 = document.createElement('script')
            script2.type = 'text/javascript'
            script2.defer = true
            script2.src = monetateScriptURL

            document.head.appendChild(script1)
            document.head.appendChild(script2)

            return () => {
                document.head.removeChild(script1)
                document.head.removeChild(script2)
            }
        }
    }, [monetateEnabled, monetateScriptURL])

    return null
}

export default MonetateScript
